import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import Link from './Link';
import { generateDatas } from './utils';

/**
 * MultiDataColumn
 * @param children {node}
 * @param data {array}
 * @param pop {bool}
 * @returns {JSX.Element}
 */
const MultiDataColumn = ({ children, data = [], pop = false }) => {
  const content = generateDatas(data);
  return (
    <>
      {pop && (
        // FIN-14012 (S1) — bottom-anchored: the default `top` placement opened the card over the
        // table header (measured on the FRAML customer Alert History tab: fully inside the
        // two-row header). The card and its selectable text are otherwise unchanged.
        <Popover
          placement="bottomLeft"
          content={
            <>
              {content}
              {children}
            </>
          }>
          {content}
          {children}
        </Popover>
      )}
      {!pop && (
        <>
          {content}
          {children}
        </>
      )}
    </>
  );
};

MultiDataColumn.propTypes = {
  children: PropTypes.node,
  data: PropTypes.array,
  pop: PropTypes.bool
};

MultiDataColumn.Link = Link;

export default MultiDataColumn;
